<template>
  <div
    class="max-w-min rounded-full p-0.5"
    :class="bgColor"
  >
    <TimesSmall custom-style="h-2.5 w-2.5 text-white" />
  </div>
</template>

<script>
export default {
  name: 'TimesRoundedSmall',
  props: {
    bgColor: {
      type: String,
      default: 'bg-red-600',
    },
  },
}
</script>
